/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: 'Share Our Passion', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  announcements: {
    gb: {
      message:
        'Not receiving our news? Please register here to ensure you get all the latest information on Destination Canada FAM trips and training events.',
      weblink: 'http://eepurl.com/iicqNz',
      img: '',
    },
  },
  loginScreen: {
    forgot: 'Reset Password?',
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to',
      headerBottom: 'Canada Specialist Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multi-media Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt: 'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    version2: {
      homeTitle: "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub: 'Enter the email address you typically use to login to training programs.',
      noAccount: 'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success: 'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount: 'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound: 'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle: 'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      step3: 'Step 3: Create Your Profile',
      milesAttack: 'Do you have a Miles Attack code? Indicate the 4 letters',
      marketingOptIn: 'Are you sure you are not interested in staying connected to this program’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy: 'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess: "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait: 'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        opt: "Stay connected to this program's travel trade team and receive updates.",
        optMarketing: 'Stay connected to TravPRO regarding similar programs and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        other: 'Other ',
        describes: 'What best describes you and your agency’s business? ',
        milesAttack: 'Miles Attack Code (optional)',
      },
    },
    fields: {
      select: 'Select an option below',
      country: 'Country',
      forgot: 'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password',
      firstName: 'First name',
      lastName: 'Last name',
      address: 'Address',
      postalCode: 'Zip Code',
      city: 'City',
      agencyName: 'Agency Name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Destionation Canada that will keep me posted on news, events, incentives, FAM’s and more!",
    },
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title: 'Thank you for your interest in the Canada Specialist Program.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Canada, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to Canada Specialist Program', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline: "Train immediately online or preload the content so it's always available for offline use!",
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    allUnlocked: 'You have unlocked all chapters!',
    completedBase: 'Congratulations, you are a certified Canada Specialist.',
    certificate: 'Certificate',
    chapter: 'Chapter',
    chapterComplete: 'Chapter complete!',
    choose: 'Please choose an answer',
    confirm: 'Confirm your answer',
    continue: 'Continue',
    welcome:
      'Simply complete modules to gain points towards your ultimate goal of becoming a Gold Canada Specialist. The bar along the right will show you exactly how you’re doing.',
    courseComplete: 'Course complete!',
    durationInMinutes: '{number} minutes',
    endReached: "You've reached the end",
    essential: 'The Foundation',
    essentialSub: 'Complete these essential chapters to earn BRONZE status and move on to the next section.',
    message: '{count} STAR Message',
    messagePlural: '{count} STAR Messages',
    percentageComplete: '{number}% Complete',
    restart: 'Restart',
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    retry: 'Try Again',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    specialization: 'Specialization Modules',
    specializationSub: 'Finish these modules to Achieve Your Silver Canada Specialist Status',
    start: 'Start',
    review: 'Review',
    status: 'Current Status:',
    tip: 'You earn your status by completing<br />the modules within each tier. <br />Dream big and reach Gold Canada Specialist status<br />by completing all modules!',
    trouble: "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    unlockFoundation: 'Unlock this chapter by completing the Foundation Chapters.',
    watchListenRead: 'Watch, Listen & Read more',
  },
  newTrainingFlow: {
    tip: 'tip: You earn your status by completing the modules within each tier.  Dream big and reach Gold Canada Specialist status by completing all modules!',
    essentialModules: 'Essential Chapters',
    finishBronze: 'Complete these essential modules to earn BRONZE status and move on to the next section.',
    specializationModules: 'Specialization Modules',
    finishSilver:
      'Explore Canada’s incredible activities & adventures to achieve SILVER status and receive your diploma!',
    partnerModules: 'Partner Modules',
    finishGold:
      'Take your knowledge to the next level and earn a badge for EACH province, territory, or city chapter you complete. Finish 10 of the 29 total chapters and earn GOLD status. Complete 22 of the 29 total chapters and reach the highest specialist status, PLATINUM!',
    currentStatus: 'Current Status',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel} XP needed to rank:  ({rank})',
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      'Nice work! You’ve learned all about the essentials of Canada and have earned BRONZE status. Next, we’ll explore the many types of experiences visitors can have here.',
    silver:
      'Congratulations! You have earned your diploma as a certified Canada Specialist by successfully completing all modules in The Foundation and The Experience. You have also achieved SILVER status and are ready to go for GOLD and beyond by proceeding into the Provinces, Territories & Cities section below. Keep up the great work!',
    gold: 'Great work! You have successfully completed 10 Provinces, Territories & Cities modules and have now earned GOLD status. Choose to complete another 12 and you become a full PLATINUM-level Canada Specialist!',
    platinum:
      'Congratulations!! You have earned PLATINUM status — the highest level of qualification as a certified Canada Specialist. Thank you for all your hard work and your partnership in selling Canada.',
    platinumWithLink: {
      start:
        'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
      end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
      link: 'HERE',
    },
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    unit: 'XP',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
    complete: {
      chapter: 'Chapter complete!',
      'intro-chapter': 'Intro Chapter complete!',
      'sub-app': 'SubApp complete!',
      rewards: 'Rewards complete!',
      multi: "You're due some points!",
    },
    completed: '{completed} / {total} Completed',
  },
  nav: {
    home: 'Home',
    train: 'Learn',
    learn: 'Learn',
    retain: 'Retain',
    achievements: 'Achievements',
    directory: 'Directory',
    showRoom: 'Hotel Spotlights',
    showcases: 'Hotel Spotlights',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    reportIncomplete: 'Report Incomplete',
    reportComplete: 'Report Complete',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Learn',
    retain: 'Retain',
    subapps: 'PROVINCES, TERRITORIES & CITIES',
    maintrainings: 'The Foundation',
    subtrainings: 'The Experience',
    leaderboard: 'Prize Center',
    dashboard: 'How to Earn More Rewards?',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'Start the conversation with your clients and prospects.',
    sell: 'Answer client questions and close the sale.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps:
      'Take your knowledge to the next level and earn a badge for EACH province, territory, or city chapter you complete. Finish 10 of the 29 total chapters and earn GOLD status. Complete 22 of the 29 total chapters and reach the highest specialist status, PLATINUM!',
    maintrainings: 'Complete the foundation modules to earn your diploma.',
    subtrainings:
      'Explore Canada’s incredible activities & adventures to achieve SILVER status and receive your diploma!',
    leaderboard:
      'Canada will host a FAM trip for advisors annually and the Top 5 on this list will ensure themselves an invitation :) Over the course of the year you can check in here to see where you stand in terms of the Top 5.   To the right you can see all the ways to earn more points and perks. Good luck and enjoy the friendly competition!​​',
    dashboard:
      'Earning more cash, points and perks from Canada is simple.  This dashboard will help you quickly see what has been already been accomplished, and what can still be done to earn like training and sharing with clients... \n\n The most earning potential comes from booking a Canada property and reporting the booking on the Submit Booking tab on the left.​',
  },
  general: {
    forgot: 'Reset Password?',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    register: 'Register',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {query}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {query}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    email: 'Email',
    facebook: 'Facebook',
    twitter: 'Twitter',
    download: 'Download',
    print: 'Print',
    copy: 'Copy Link',
    copyUrl: 'Copy Link',
    copied: 'Copied',
    shareSubjectDiploma: 'My Canada Specialist Program Diploma',
    shareSubjectBadge: 'My Canada Specialist Program Badge',
    shareBodyDiploma:
      "I'm excited to share that I am now a certified Canada Specialist! This means that I have the expertise and insider access to help you plan the best vacation possible. Please contact me when you're ready to start planning.",
    shareBodyBadge:
      "I wanted to let you know that I'm now a certified specialist in {chapterTitle}, and I'm happy to answer your questions and help you plan your next amazing trip. Let me know when you're ready to go!",
    shareBodyProgress:
      "I wanted to let you know that I'm now a certified {rank}status specialist, and I'm happy to answer your questions and help you plan your next amazing trip. Let me know when you're ready to go!",
    shareBody:
      'I thought this would interest you. Take a minute to view the attached content. Look forward to connecting with you soon!',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Learn, Promote & Sell on the Go',
      2: 'Multi-media Training Across Devices',
      3: 'Certificate of Completion',
      4: 'Ready-made Sales Presentations',
      5: 'High-impact Promotional Materials',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  rewards: {
    profile: 'Your Profile',
    rewards: 'Rewards',
    title: 'Welcome to the Rewards Center',
    subheader: 'Track and Share Booking Submissions and Rewards',
    subTitle:
      'We’re giving you a chance to win rewards for becoming a specialist with our program, and booking travel to The Canada!',
    body: 'Book travel to The Canada for your chance to win! Enter your bookings for eligibility to earn an Introductory Incentive Reward of $5 US/CAN E-gift Card.',
    item1:
      'After your first confirmed booking of 4-nights or more, (for an individual reservation), for a minimum of two (2) passengers, at a qualifying hotel/resort. (Cruises do not qualify.)',
    item2: 'Offer valid after Essential Modules of the Canada Specialist Programme Program are completed.',
    link1: 'Have you booked the Canada? ',
    link2: 'If so, submit your booking here.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings Dashboard',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Achievements Dashboard',
    viewRewards: 'Rewards Home',
    form: 'SUBMIT BOOKING ',
    menu: {
      home: 'Rewards\nCenter',
      achievements: 'Training\nAchievements',
      bookings: 'Bookings\nDashboard',
      form: 'Submit\nBookings',
    },
    overview: {
      title: 'Welcome to the Canada Specialist Program Rewards Center.',
      subtitle: 'Use this special section to track your training progress, achievements, and rewards.',
      description: "Here's how:",
      dashboard: {
        title: 'Achievements Dashboard',
        description:
          'Track your training progress, diploma, and badges earned by visiting the Achievements Dashboard. As you work your way from Bronze to Platinum levels, you can watch your status grow on the tracker bar.',
        bronze: 'BRONZE status is earned after completing Foundation chapters',
        silver: 'SILVER status is earned, along with your diploma, after completing Experience chapters',
        gold: 'GOLD status is earned after completing 10 Provinces/Territories/Cities chapters',
        platinum: 'PLATINUM status is earned after completing 22 Provinces/Territories/Cities chapters',
      },
      platinumRewards: {
        title: 'Platinum Rewards',
        description:
          "Platinum-level Canada Specialists earn special rewards like Destination Experience Passes from our destination partners. Once you receive your Platinum badge in the Achievements Dashboard, you'll get a list of the available Experience Passes and instructions for redemption. Redemption requires that you download your Platinum Badge to send for verification to the destination partners.",
      },
      downloads: {
        title: 'Downloads',
        description:
          'The Achievements Dashboard allows you to view and download your Canada Specialist Diploma, badges for Provinces/Territories/Cities, as well your metallic status badges. Just click the icon to open and save to your computer and share proudly with your clients and prospects.',
      },
      termsNotice: {
        start: 'See terms',
        end: 'for more details.',
        link: ' Terms & Conditions ',
      },
      rewards: {
        title: 'Rewards',
        description: {
          start: 'Platinum-level Canada Specialists earn special rewards like',
          end: "from our destination partners. Once you receive your Platinum badge in the Achievements Dashboard, you'll get a list of the available Experience Passes and instructions for redemption.",
          bold: 'Destination Experience Passes',
        },
      },
    },
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your diploma, as well as any badges you’ve earned.',
      bookingDashboard: 'BOOKINGS DASHBOARD',
      bookingDashboardText: 'Easily track and manage current booking submissions on the Bookings Dashboard. ',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText: 'This is where you’ll submit bookings for inclusion in booking contests.',
      currentContest: 'CURRENT CONTEST',
      currentContests: 'CURRENT CONTESTS',
      contestHeader: 'Win cash prizes on bookings each month!',
      contestPrizes:
        'Enter your hotel, ground services, and car rental bookings each month for a chance to win three great prizes:',
      contestPrize1: 'One (1) $250 Gift Card',
      contestPrize1Description: ' will be awarded to the advisor with the most bookings/entries* for the month',
      contestPrize2: 'Two (2) $100 Gift Cards',
      contestPrize2Description: ' will be awarded to two lucky advisors through a random drawing',
      contestConditions: '*One (1) Entry will be given to each qualifying booking:',
      contestLodging: 'Lodging: ',
      contestCondition1: 'Bookings must be 3 nights or more',
      contestGroundServices: 'Ground Services:  ',
      contestCondition2: '3 services or more (e.g., Meet & Greet, transfer, and sightseeing)',
      contestCarRental: 'Car Rental: ',
      contestCondition3: 'must be 3 days or more',
      contestStartEarning: 'Start earning your chances to win by ',
      contestEnterBookings: 'entering your bookings',
      contestNow: ' now!',
      contestSeeOther: 'See other ',
      contestTerms: 'Terms & Conditions',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      rowsPerPage: 'Rows per page',
      rangeSeparator: 'of',
      selectAllRowsItem: 'all',
      title: 'Bookings Dashboard',
      subtitle: 'Track and Manage Your Booking Entries Here.',
      manage: 'Manage Bookings',
      manageSub:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours. ',
      noBookings: 'There are no records to display.',
      statusCategories: {
        confirmedentries: 'Approved Entries',
        pendingentries: 'Pending Entries',
        rejectedentries: 'Declined Entries',
        viewall: 'View All',
      },
      columns: {
        reservationNumber: 'Reservation Number',
        status: 'Status',
        firstName: 'First Name',
        numberOfGuests: 'Number of Guests',
        lengthOfStay: 'Length of Stay',
      },
    },
    leaderboardScreen: {
      title: 'LC POINTS \n Leaderboard',
      earnedpts: 'MY LC POINTS EARNED​:',
      pointsWall: 'LC POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Your Earnings Dashboard',
    },
    bookingForm: {
      title: 'Booking Submission Form​',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Advisor email',
      agentFirstName: 'Advisor First Name',
      agentLastName: 'Advisor Last Name',
      company: 'Agency / Company Name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip / Postal Code',
      country: 'Country',
      city: 'City',
      birthday: 'Birthday',
      type: 'Guest Trip Type',
      source: 'Booking Source',
      select: 'Please select an option',
      tourOperator: 'Tour Operator',
      provinceVisited: 'Province or Territory Visited',
      firstName: 'Guest First Name',
      lastName: 'Guest Last Name',
      bookingNumber: 'Booking Confirm Number',
      file: 'RezSnap™ Proof Upload ',
      arrivalDate: 'Property Arrival Date',
      pax: 'Pax',
      departureDate: 'Property Departure Date',
      brand: 'LC Brand Booked',
      lengthOfStay: 'Length of Stay (in Nights)',
      cost: 'Total Cost of Booking',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline/ Carrier (2- digit code)',
      gateway: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      editInfo: 'Edit your info',
      dropzone: 'Drag and drop a file here, or click to select a file.',
      dropzoneAcceptedFiles: 'One file, .jpeg, .png and .pdf files will be accepted. Max file size is 100mb.',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Canada Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Return to landing',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
      link: 'Please note to be a winner, you must have completed the Essential Modules of the Canada Specialist Program',
    },
    bookingTable: {
      points: 'Points',
      status: 'Status',
      firstName: 'First name',
      lastName: 'Last name',
      bookingDate: 'Booking date',
      rooms: 'Rooms',
      cost: 'Cost',
    },
  },
  badgeView: {
    title: 'Training Achievements',
    subtitle:
      'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your Canada Travel Specialist diploma, as well as any badges you’ve earned.',
    viewBadge: 'View Status',
    badgeDisplayTitle: 'Metallic Achievement Status',
    badgeAchievement:
      'You have achieved {rank} Status! Click the icon on the badge below to view and share your status.',
    badgesCompleteTitle: 'Your specialization badges',
    badgesCompleteSubtitle: 'Click the icons to view, save and share your badges.',
    badgesIncompleteSubtitle: 'Earn more badges by completing these chapters.',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    complete: 'Complete',
    diploma: 'Diploma',
    badgeAchievementWithRewards: {
      start: 'Congratulations! You have reached Platinum Status. Click ',
      link: 'here',
      end: ' to access your Platinum Status reward.',
    },
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
